export { default as TypingAnimation } from "./src/";
